import React, { FC } from 'react';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { Container } from '@fiverr-private/layout_components';
import { WorkExperience } from '../../../gql-operations/gql-generated';
import { employmentTypeEnumToTranslationKey, formatDateRange, shouldDisplayEmploymentType } from '../utils';

const T_KEY = 'seller_pages_toolbox.work_experience';

interface CompanyTitleProps {
    companyName: string;
    companyExperiences: WorkExperience[];
}

const CompanyTitle: FC<CompanyTitleProps> = ({ companyName, companyExperiences }) => {
    const dateRange = formatDateRange(
        companyExperiences[companyExperiences.length - 1].startDate,
        companyExperiences[0].endDate?.valueOf(),
        { onlyDuration: true }
    );

    const shouldDisplayEmploymentTypeValue = shouldDisplayEmploymentType(companyExperiences[0]);

    return (
        <Container
            marginBottom={!shouldDisplayEmploymentTypeValue && !dateRange ? '8' : '3'}
            data-testid="timeline-company-title"
        >
            <Text fontWeight="semibold">{companyName}</Text>
            <Text size="b_sm">
                {shouldDisplayEmploymentTypeValue && (
                    <>
                        <I18n
                            k={`${T_KEY}.employment_type.${
                                employmentTypeEnumToTranslationKey[companyExperiences[0].employmentType]
                            }`}
                        />{' '}
                    </>
                )}
                {shouldDisplayEmploymentTypeValue && dateRange && '• '}
                {dateRange}
            </Text>
        </Container>
    );
};

export default CompanyTitle;
